import { useDispatch } from 'react-redux';
import api from './axiosInstance.js';
import {
  setFontLoading,
  setRecommendedFontList,
  setFontError,
  setEditFontLoading,
  setEditFontList,
  setEditFontError,
  setRecommendedFontListFromMd5,
} from '../redux/fontListSlice.js';
import { setEmptyGeneratedImages } from '../redux/createImageSlice.js';
import { hideToast } from '../redux/toasterSlice.js';

export const useFetchFonts = () => {
  const dispatch = useDispatch();

  const fetchFonts = async (prompt, inventories = null) => {
    try {
      dispatch(setFontLoading(true));
      const response = await api.get(`/get-fontList?prompt=${prompt}&inventories=${inventories}`);

      dispatch(setRecommendedFontList(response.data.data));
      dispatch(setEmptyGeneratedImages());
      if (response.data.data.length === 0) {
        dispatch(hideToast());
      }
      return response.data.data[0];
    } catch (error) {
      dispatch(setFontError('Failed to fetch fonts'));
      dispatch(hideToast());
    }
  };

  const fetchFontsForEditFont = async (prompt, replaceFontList) => {
    try {
      if (replaceFontList) {
        dispatch(setFontLoading(true));
      }
      dispatch(setEditFontLoading(true));
      const response = await api.get(`/get-fontList?prompt=${prompt}`);
      dispatch(setEditFontList(response.data.data));
      if (replaceFontList) {
        dispatch(setRecommendedFontList(response.data.data));
      }
      if (response.data.data[0].length === 0) {
        dispatch(hideToast());
      }
      return response.data;
    } catch (error) {
      dispatch(setEditFontError('Failed to fetch fonts'));
    }
  };

  return { fetchFonts, fetchFontsForEditFont };
};

export const useFetchFontsWithMd5Hash = () => {
  const dispatch = useDispatch();

  const fetchFontsWithMd5 = async (md5) => {
    try {
      dispatch(setFontLoading(true));
      const response = await api.get(`/fbms-details/${md5}`);
      const data = [
        {
          md5: response?.data?.data[0]?.md5,
          font_name: response?.data?.data[0]?.names.fullName,
          family_url: '',
          foundry_name: ''
        }
      ];

      dispatch(setRecommendedFontList(data));
      dispatch(setEmptyGeneratedImages());
      return data[0];
    } catch (error) {
      dispatch(setFontError('Failed to fetch fonts'));
    }
  };
  const fetchFontsWithMd5FormUrl = async (md5, family_url) => {
    try {
      dispatch(setFontLoading(true));
      const response = await api.get(`/fbms-details/${md5}`);
      const data = [
        {
          md5: response?.data?.data[0]?.md5,
          font_name: response?.data?.data[0]?.names.fullName,
          family_url: family_url,
          foundry_name: ''
        }
      ];

      dispatch(setRecommendedFontListFromMd5(data));
      dispatch(setEmptyGeneratedImages());
      return data[0];
    } catch (error) {
      dispatch(setFontError('Failed to fetch fonts from md5'));
    }
  };

 
  return { fetchFontsWithMd5, fetchFontsWithMd5FormUrl };
};
